var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col" },
    [
      _vm._l(_vm.meters, function (meter) {
        return [
          _vm.map[meter.key] && _vm.map[meter.key].fn(meter)
            ? _c("div", { staticClass: "flex items-center" }, [
                _c("img", {
                  staticClass: "h-4 w-4 mr-1",
                  attrs: { src: _vm.map[meter.key].svg },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.map[meter.key].fn(meter)))]),
              ])
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./resources/js/Components/new/MetersComponent.vue